export default __webpack_public_path__ + "static/media/Logos ACNDC.78aa1d8a.png";